import { render, staticRenderFns } from "./bc-iso-9001-certificate.vue?vue&type=template&id=46ddbe34&"
import script from "./bc-iso-9001-certificate.vue?vue&type=script&lang=js&"
export * from "./bc-iso-9001-certificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports